import { NutriValuesWithoutKcal } from "../data/nutriValues";

export function computeCalories({
  carbs,
  fat,
  protein,
}: NutriValuesWithoutKcal) {
  return carbs * 4 + fat * 9 + protein * 4;
}
